import React, { useCallback, useEffect } from 'react';
import Animated from 'react-native-reanimated';
import { AppView, CardView, SCROLL_INDICATOR_INSETS, SettingsItemNavigate, SettingsItemTitle, withAnimatedNavigationHeader, } from 'design-system';
import ScreenInfoHeader from 'design-system/ScreenInfoHeader';
import StatusBar from 'design-system/StatusBar';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useMarginBottom } from 'hooks/useMarginBottom';
import Amplitude from 'utils/amplitude';
import { logDeleteReasonsScreen } from './analytics';
import useNavigateAfterIssueStep from './hooks/useNavigateAfterIssueStep';
import { DeleteReasonID, reasonsV3 } from './reasons';
const strings = {
    title: 'Why would you like to delete?',
};
const DeleteReasonsScreen = withAnimatedNavigationHeader(({ navigation, scrollHandler }) => {
    useEffect(() => {
        logDeleteReasonsScreen('delete');
    }, []);
    const navigateAfterIssueStep = useNavigateAfterIssueStep();
    const onPress = useCallback((id, reason) => {
        switch (id) {
            case DeleteReasonID.AppBroken:
            case DeleteReasonID.DontKnowHowToUse:
            case DeleteReasonID.ItsNotWorking:
                navigation.navigateDeprecated('DeleteFeatureIssue', { reason: id });
                break;
            case DeleteReasonID.DontTrust:
                navigateAfterIssueStep();
                break;
            case DeleteReasonID.TooExpensive:
                navigation.navigateDeprecated('DeleteBenefits');
                break;
            case DeleteReasonID.UseAnotherApp:
                navigation.navigateDeprecated('DeleteSelectApp', { reason: id });
                break;
            case DeleteReasonID.BankDoesTheSame:
            case DeleteReasonID.DontSupportAccounts:
                navigation.navigateDeprecated('DeleteText', { reason: id });
                break;
            case DeleteReasonID.WantAFreshStart:
                navigation.navigateDeprecated('DeleteFreshStart');
                break;
            default:
                break;
        }
        Amplitude.logEvent('Delete.Reasons', {
            reason: { reason },
        });
    }, [navigateAfterIssueStep]);
    const { paddingHorizontalStyle } = useAppFrameDimensions();
    const paddingBottom = useMarginBottom('paddingBottom', undefined, paddingHorizontalStyle);
    return (<AppView withFrame={false}>
        <StatusBar barStyle="dark-content" animated/>
        <Animated.ScrollView onScroll={scrollHandler} scrollIndicatorInsets={SCROLL_INDICATOR_INSETS} scrollEventThrottle={16} contentContainerStyle={paddingBottom}>
          <ScreenInfoHeader title="Why would you like to delete your account?" subTitle="Let us understand a bit better" smallSubTitle/>
          <CardView noMarginTop>
            {reasonsV3.map((r) => (<SettingsItemNavigate key={r.reason} icon={r.icon} onPress={() => {
                onPress(r.id, r.reason);
            }}>
                <SettingsItemTitle numberOfLines={undefined}>
                  {r.reason}
                </SettingsItemTitle>
              </SettingsItemNavigate>))}
          </CardView>
        </Animated.ScrollView>
      </AppView>);
}, ({ colors }) => ({
    title: strings.title,
    hideTitleOnScroll: true,
    headerColorOutputRange: [
        colors.background.dark,
        colors.cards.onDark,
    ],
}));
export default DeleteReasonsScreen;
